var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.75104 14.1073C9.05763 15.3083 7.32412 15.3083 6.63071 14.1073L0.390059 3.29816C-0.303346 2.09714 0.563412 0.59588 1.95022 0.59588L14.4315 0.595881C15.8183 0.595881 16.6851 2.09715 15.9917 3.29816L9.75104 14.1073Z",
    fill: "#2650FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.547f61917a1d07f0a673387e9c3b418f.svg";
export { ForwardRef as ReactComponent };